module.exports = __webpack_public_path__ + "img/travelmore.d184932f.png";